import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'



class SetOrderType extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            orderTypeChoices: [],
        }
    }

    componentDidMount() {
        //SHIRT COLORS
        base.fetch('admin/orderTypes', {
            context: this,
            asArray: true,
            then(data) {
               // console.log(data);
                this.setState({
                    orderTypeChoices: data
                })
            }
        });
    }

    /**
* HANDLE DROPDOWN FOR ORDER ONE
*/
    handleDropDownChanges = (value) => {
        console.log("lst1 handleDropDownChanges");
        console.log('lst12 You\'ve sss:', value);
        console.log("lst13 category alone:" + value.category);
        console.log('lst14 You\'ve selected:', value.value + " " + value.category);
        console.log("lst15 -  this.props.itemSelected:" + this.state.itemSelected);
        console.log("lst16 - array index:" + this.props.arrayIndex);

        let newState = {};
        newState[value.category] = value.value;
        console.log("newState 1:" + JSON.stringify(newState, null, 3));

        //this.setState(newState);
        this.setState(newState);
    }

    selectorderType = () => {
        console.log("mk1 ++++++++++++++ selectDesigner");

        let now = moment().format('MMMM Do YYYY, h:mm:ss a');
        let orderUpdates = {
            orderType: this.state.orderType,
            lastUpdated: now,
            //lastUpdatedBy:this.props.user.email,
            orderTypePickedBy:this.props.user.email
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        axios.post(serverIp + 'orders/setOrderType', {
            apiKey: "PrintB@da7",
            fbOrderKey: this.props.order.key,
            adminEmail: this.props.user.email,
            orderType:this.state.orderType
        })
            .then(function (response) {
                console.log(response.data);
            })
            .catch(function (error) {
                console.log(error);
            });

    }

    render() {

        const showDesigner = this.props.order.orderType
            ? <h4>ORDER TYPE:{this.props.order.orderType}</h4>
            :''

        const lostButton = this.state.orderType !== ''
            ? <Button onClick={this.selectorderType}> SET orderType</Button>
            : ''

        const wholeUi = this.props.user.email == "ivanmworozi@gmail.com"
            ? <div>
                <Divider horizontal>{'setType!'}</Divider>
                {showDesigner}
                <Select
                    name="form-field-name"
                    value={this.state.orderType}
                    options={this.state.orderTypeChoices}
                    onChange={this.handleDropDownChanges}
                    searchable={false}
                    clearable={false}
                />
                {lostButton}
            </div>
            : ''


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default SetOrderType;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/SetOrderType/SetOrderType.js